import { render, staticRenderFns } from "./organization-delete.view.vue?vue&type=template&id=34f53ecc&"
import script from "./organization-delete.view.vue?vue&type=script&lang=ts&"
export * from "./organization-delete.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports